import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/globo_white.svg")